var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_877_1803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_877_1803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 17.5H10C10.2833 17.5 10.5208 17.5958 10.7125 17.7875C10.9042 17.9792 11 18.2167 11 18.5C11 18.7833 10.9042 19.0208 10.7125 19.2125C10.5208 19.4042 10.2833 19.5 10 19.5H6C5.71667 19.5 5.47917 19.4042 5.2875 19.2125C5.09583 19.0208 5 18.7833 5 18.5V14.5C5 14.2167 5.09583 13.9792 5.2875 13.7875C5.47917 13.5958 5.71667 13.5 6 13.5C6.28333 13.5 6.52083 13.5958 6.7125 13.7875C6.90417 13.9792 7 14.2167 7 14.5V17.5ZM17 7.5H14C13.7167 7.5 13.4792 7.40417 13.2875 7.2125C13.0958 7.02083 13 6.78333 13 6.5C13 6.21667 13.0958 5.97917 13.2875 5.7875C13.4792 5.59583 13.7167 5.5 14 5.5H18C18.2833 5.5 18.5208 5.59583 18.7125 5.7875C18.9042 5.97917 19 6.21667 19 6.5V10.5C19 10.7833 18.9042 11.0208 18.7125 11.2125C18.5208 11.4042 18.2833 11.5 18 11.5C17.7167 11.5 17.4792 11.4042 17.2875 11.2125C17.0958 11.0208 17 10.7833 17 10.5V7.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.c7cd9580eb575783efa0815e32d5a5a7.svg";
export { ForwardRef as ReactComponent };